<template>
  <div class="wrap">
    <div v-for="(item, index) in carList" :key="index">
      <p>{{ item.year }}</p>
      <div v-for="(item1, index) in item.carModels" :key="index" class="towfor">
        <div class="flex" @click="toYear(item1.id)">
          <van-radio-group v-model="carTypeName" @change="changes">
            <van-radio :name="item1.name">{{ item1.name }}</van-radio>
            <!-- <p class="p-name">{{ item1.name }}</p> -->
          </van-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { yearbran } from "@/api/api.config";
export default {
  data() {
    return {
      carList: [],
      seriesId: '',
        brand:"",
        carSeriesName:"",
        carTypeId:"",
        carTypeName:"",
    };
  },
  methods: {
    async yearbran() {
      let result = await yearbran(this.seriesId);
      this.carList = result.data.data;
    },
    toYear(carTypeId) {
      this.carTypeId = carTypeId
      this.$router.push({
        path:"/home",
        query:{brand:this.brand,carSeriesName:this.carSeriesName,carTypeId:this.carTypeId,carTypeName:this.carTypeName}
      })
      console.log('品牌'+this.brand,'车系'+this.carSeriesName,'最后id'+this.carTypeId,'最后名字'+this.carTypeName)
    },
    changes(e){
       this.carTypeName = e
    }
  },
  mounted() {
    this.yearbran();
  },
  created() {
    this.seriesId = this.$route.query.seriesId;
    this.brand = this.$route.query.brand;
    this.carSeriesName = this.$route.query.carSeriesName;
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  p {
    height: 40px;
    background: #fcfdff;
    line-height: 40px;
    padding: 0px 30px;
    color: #666666;
  }
  .towfor {
    padding: 0px 50px;
    .flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 80px;
      .p-name {
        font-weight: 800;
        color: #333333;
        padding: 0px;
      }
      span {
        color: grey;
      }
    }
  }
}
</style>
